import { typeList, controllist, addTemplate, editTemplate, templateDetail } from './request';
export default {
  data() {
    return {
      dialogVisible: false,
      typeList: typeList,
      controlList: controllist,
      dataFrom: {
        type: undefined,
        display: undefined,
        code: '',
        name: '',
        sort: '',
        isTag: 0
      }
    };
  },
  computed: {
    dataRule() {
      return {
        name: [{
          required: true,
          message: this.$t('请输入') + this.$t('名称'),
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: this.$t('请选择') + this.$t('类型'),
          trigger: 'change'
        }],
        code: [{
          required: true,
          message: this.$t('请输入') + this.$t('代码'),
          trigger: 'blur'
        }],
        sort: [{
          required: true,
          message: this.$t('请输入') + this.$t('排序'),
          trigger: 'blur'
        }],
        display: [{
          required: true,
          message: this.$t('请选择') + this.$t('控件'),
          trigger: 'change'
        }],
        isTag: [{
          required: true,
          message: this.$t('请选择') + this.$t('是否生成标签'),
          trigger: 'change'
        }]
      };
    }
  },
  methods: {
    init(data) {
      if (data.type2 != 'add') {
        templateDetail({
          templateId: data.id
        }).then(res => {
          console.log(res);
          this.dataFrom = {
            templateId: res.templateId,
            type: res.type,
            display: res.display,
            code: res.code,
            name: res.name,
            sort: res.sort,
            isTag: res.isTag || 0
          };
        });
      }
      this.dialogVisible = true;
    },
    handleSure() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          let fun = this.dataFrom.templateId ? editTemplate : addTemplate;
          fun(this.dataFrom).then(res => {
            this.$message.success(this.$t('操作成功') + '!');
            this.$emit('ok');
            this.$emit('cancel');
          });
        }
      });
    }
  }
};